//平铺数据
export function processTableData(tableData) {
  if (!tableData?.length) return [];

  const flattenedData = [];
  let masterIndex = 0; // 主数据索引计数器
  const subCountMap = new Map(); // 记录每个组的次数据计数

  tableData.forEach(parent => {
    // 为每组生成唯一code
    const groupCode = generateUniqueCode();

    // 主数据序号+1
    masterIndex++;
    subCountMap.set(groupCode, 0); // 初始化次数据计数

    // 处理父级数据（主数据）
    const masterData = createMasterData(parent, groupCode, masterIndex);
    flattenedData.push(masterData);

    // 处理子级数据（服务清单数据）
    if (parent.children && parent.children.length > 0) {
      parent.children.forEach(child => {
        // 子级数据计数+1
        const subCount = subCountMap.get(groupCode) + 1;
        subCountMap.set(groupCode, subCount);

        const serviceData = createServiceData(
          child,
          groupCode,
          masterIndex,
          subCount
        );
        flattenedData.push(serviceData);
      });
    }
  });

  return flattenedData;
}
// 主数据
export function createMasterData(parent, groupCode, masterIndex) {
  const masterData = { ...parent };
  // 移除children属性
  delete masterData.children;
  // 添加分组标识
  masterData.code = groupCode;
  masterData.isService = false;
  // 添加序号
  masterData.index_1 = masterIndex.toString();
  return masterData;
}
// 服务清单数据
export function createServiceData(child, groupCode, masterIndex, subIndex) {
  return {
    ...child,
    code: groupCode,
    isService: true,
    index_1: `${masterIndex}.${subIndex}`
  };
}
// 生成唯一code
export function generateUniqueCode() {
  // 使用时间戳 + 随机数
  return `group_${Date.now()}_${Math.random()
    .toString(36)
    .substr(2, 9)}`;
}
